import { useState, useEffect, useCallback } from "react";
import { useLocation, Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { getCasinoGameDetails, getMatchExposure } from "@/services/casinoApi";
import CasinoHeading from "../components/common/CasinoHeading";
import VideoBox from "../components/common/VideoBox";
import BetTableCard32B from "../components/card32b/BetTableCard32B";
import ResultCard32B from "../components/card32b/ResultCard32B";
import RightSection from "../components/RightSection/RightSection";
import styles from "./Card32B.module.css";

function extractCasinoGame(url) {
  const match = url.match(/\/lord-games\/([^/?#]+)/);
  return match ? match[1] : null;
}

// Helper function to normalize string for matching
const normalizeString = (str) => {
  if (!str) return "";
  return str.replace(/\s+/g, ' ').trim().toLowerCase();
};

// Helper function to create all exposure key variations
const createExposureKeys = (selection) => {
  if (!selection) return [];
  const keys = [
    selection,
    selection.toLowerCase(),
    selection.toLowerCase().trim(),
    selection.trim(),
    normalizeString(selection),
  ];
  return [...new Set(keys.filter(k => k))];
};

export default function Card32B() {
  const [gameData, setGameData] = useState([]);

  console.log("gameData", gameData);
  const [activeTab, setActiveTab] = useState("game");
  const [iframeSrc, setIframeSrc] = useState("");
  const { pathname } = useLocation();
  const [bettingData, setBettingData] = useState([]);
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);

  useEffect(() => {
    const name = extractCasinoGame(pathname) || "card32eu";
    setIframeSrc("https://livestream-v3-iframe.akamaized.uk/casinoStream?id=card32eu&key=scoreswift.in");

    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails(name);
        setGameData(response);
        const subData = response?.data?.data?.sub || response?.data?.sub || response?.sub || [];
        // Pass the entire sub array so BetTableCard32B can find data by nat name
        setBettingData(subData.length > 0 ? [subData] : []);
      } catch (err) {
        console.error("Error fetching game data:", err);
      }
    };

    // Start API calls after 5 seconds delay
    let intervalId = null;
    const initialTimeout = setTimeout(() => {
      fetchGameData();
      intervalId = setInterval(fetchGameData, 1500);
    }, 5000);

    return () => {
      clearTimeout(initialTimeout);
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [pathname]);

  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const userId = user?.user_id || user?.id;
      const matchId = gameData?.mid?.toString() || gameData?.data?.data?.mid?.toString() || gameData?.data?.mid?.toString();

      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response.success && response.data) {
          const exposureMap = {};
          response.data.forEach((item) => {
            const teamName = item.team_name || item.selection || item.player_name || item.nat || "";
            const exposureAmount = parseFloat(item.exposure_amount || item.exposure || 0) || 0;
            if (teamName && exposureAmount !== 0) {
              // Create keys for the team name as-is
              const keys = createExposureKeys(teamName);
              keys.forEach(key => {
                if (key) exposureMap[key] = exposureAmount;
              });
            }
          });
          setExposures(exposureMap);
        }
      }
    } catch (error) {
      console.error('Error fetching exposure:', error);
    }
  }, [gameData?.mid, gameData?.data?.data?.mid, gameData?.data?.mid]);

  useEffect(() => {
    const matchId = gameData?.mid?.toString() || gameData?.data?.data?.mid?.toString() || gameData?.data?.mid?.toString();
    if (!matchId) return;

    // Start exposure fetch after 5 seconds delay
    const timeoutId = setTimeout(() => {
      fetchExposure();
    }, 5000);

    const intervalId = setInterval(() => {
      fetchExposure();
    }, 5000);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, [gameData?.mid, gameData?.data?.data?.mid, gameData?.data?.mid, fetchExposure]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleBetClick = (value, name, type, betData) => {
    // Betting functionality can be added later (admin view - no bet login)
    console.log("Bet clicked:", { value, name, type, betData });
  };

  const roundId = gameData?.mid || gameData?.data?.data?.mid || gameData?.data?.mid || "157250124095658";

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.sectionA}>
          <CasinoHeading
            name="32 CARDS B"
            roundId={roundId}
            placedBetCount={myBets.length}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />

          {activeTab === "game" && (
            <>
              <VideoBox
                gameType="card32b"
                resultData={gameData?.data?.data?.card}
                iframeSrc={iframeSrc}
                timerValue={gameData?.data?.data?.lt}
              />

              <div className={styles.tableContainer}>
                <div className={styles.bettable}>
                  <BetTableCard32B
                    data={bettingData}
                    onBetClick={handleBetClick}
                    exposures={exposures}
                    myBets={myBets}
                  />
                </div>
              </div>

              <div className={styles.heading}>
                <div>Last Result</div>
                <Link to="/casino/results/card32b">
                  <div className={styles.viewAll}>View All</div>
                </Link>
              </div>

              <ResultCard32B
                data={gameData?.lrs || []}
                gameData={gameData}
              />
            </>
          )}

          {activeTab === "placedBet" && (
            <div className="mt-4 p-4 bg-[rgba(0,0,0,0.4)] rounded">
              <div className="text-white text-center text-xl">Coming Soon</div>
            </div>
          )}
        </div>

        <RightSection
          sectionKey="card32b"
          data={myBets}
          title="Matched"
          viewMoreText="View More"
          onViewMore={() => {
            console.log("View more clicked for card32b");
          }}
        />
      </div>
    </Layout>
  );
}

